import { initContract } from '@ts-rest/core';
import {
  FeedbackOfferCheckoutResponseSchema,
  FeedbackSurveyWebhookResponseSchema,
  MailerLiteSurveyCompletionWebhookSchema,
} from '../schemas/feedback-offer';
import { defaultErrorResponses } from './errors';

const c = initContract();

export const feedbackOfferContract = c.router({
  acceptSurveyCompletion: {
    method: 'POST',
    path: '/v1/webhooks/mailerlite/feedback-survey',
    body: MailerLiteSurveyCompletionWebhookSchema,
    responses: {
      202: FeedbackSurveyWebhookResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: false,
      summary: 'Accept a MailerLite feedback survey completion event',
      description:
        'Validates a signed MailerLite completion-group event and activates the annual feedback offer.',
    },
  },
  getCheckout: {
    method: 'POST',
    path: '/v1/feedback-offer/checkout',
    body: c.noBody(),
    responses: {
      200: FeedbackOfferCheckoutResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Get the feedback survey annual offer checkout',
      description:
        'Returns the authenticated user offer state and Stripe Checkout URL when the verified offer is ready.',
    },
  },
});
